import { createChatWoot } from '@productdevbook/chatwoot/vue';
import { mainDomain } from '@/utils/variables';
import { ref, computed } from 'vue';
const wootToken = import.meta.env.VITE_CHATWOOT_TOKEN;
export const useLiveChat = () => {
    const chatwoot = ref(null);
    const showLiveChat = computed(() => {
        return !mainDomain.includes('takemybet');
    });
    if (showLiveChat.value) {
        chatwoot.value = createChatWoot({
            init: {
                websiteToken: wootToken
            },
            settings: {
                locale: 'en',
                position: 'right',
                launcherTitle: 'Need help?'
            }
        });
    }
    return { chatwoot, showLiveChat };
};
